<!-- @format -->

<app-admin-header *ngIf="hasAccess(['ADMIN'])"></app-admin-header>
<app-mda-header *ngIf="hasAccess(['MDA'])"></app-mda-header>
<div class="user-mgt-bg">
	<div class="container pt-4">
		<div class="page-topbar mb-3">
			<button class="back-button" (click)="goBack()">
				<span class="material-icons" style="font-size:16px;vertical-align:middle;margin-right:4px">arrow_back</span>Back
			</button>
			<span class="page-title">{{ userDetail?.displayname | titlecase }}'s Tax Record</span>
		</div>

		<div class="profile-shell mb-4">

			<!-- ── Profile Hero ── -->
			<div class="profile-hero">
				<!-- Avatar -->
				<div class="avatar-wrap">
					<img *ngIf="showProfilePhoto" src="{{ userDetail?.photo }}" class="avatar-img" />
					<div *ngIf="!showProfilePhoto" class="avatar-initials">
						{{ userDetail?.displayname?.split(" ")[0]?.[0] }}{{ userDetail?.displayname?.split(" ")[1]?.[0] }}
					</div>
				</div>

				<!-- Name, ASIN, badges -->
				<div class="profile-meta">
					<span class="profile-name">{{ userDetail?.displayname }}</span>

					<div class="d-flex align-items-center gap-2 flex-wrap mt-1">
						<span class="profile-asin">ASIN: <strong>{{ userDetail?.tinNumber }}</strong></span>
						<button class="copy-btn" (click)="copyASIN(userDetail?.tinNumber)" title="Copy ASIN">
							<span class="material-icons" style="font-size:13px">content_copy</span>
						</button>
						<span class="copy-msg" *ngIf="copy_message">{{ copy_message }}</span>
						<button class="jtb-tin-btn" (click)="fetchJtbTin()" [disabled]="loadingJtbTin" title="View JTB TIN">
							<span class="material-icons" style="font-size:13px;vertical-align:middle">
								{{ loadingJtbTin ? 'hourglass_empty' : 'fingerprint' }}
							</span>
							JTB TIN
						</button>
					</div>
					<div *ngIf="showJtbTin" class="jtb-tin-reveal">
						<span class="jtb-tin-label">JTB TIN:</span>
						<strong class="jtb-tin-value">{{ jtbTin || 'Not found' }}</strong>
						<button class="jtb-tin-hide-btn" (click)="hideJtbTin()">
							<span class="material-icons" style="font-size:12px;vertical-align:middle">visibility_off</span> Hide
						</button>
					</div>

					<div class="profile-badges mt-2">
						<span class="badge-type" *ngIf="userDetail?.taxgroup == 'USER'">Individual</span>
						<ng-container *ngIf="userDetail?.taxgroup == 'INFORMAL' || userDetail?.taxgroup == 'COMPANY'">
							<select [(ngModel)]="selectedUserType" class="type-switcher" (change)="changeUserType()">
								<option [value]="userType1">{{ userType1 | titlecase }}</option>
								<option [value]="userType2">{{ userType2 | titlecase }}</option>
							</select>
						</ng-container>
						<span class="badge-status">{{ userDetail?.status }}</span>
					</div>
				</div>

				<!-- Right: upload, enumerated, date -->
				<div class="ms-auto d-flex flex-column align-items-end gap-3">
					<div *ngIf="userDetail?.taxgroup != 'INFORMAL' && userDetail?.taxgroup != 'COMPANY'">
						<p *ngIf="!showProfilePhoto" class="upload-hint mb-1">Min. 300×300px</p>
						<button class="upload-photo-btn" (click)="openCropModal()">
							<span class="material-icons" style="font-size:14px">{{ showProfilePhoto ? 'edit' : 'upload' }}</span>
							{{ showProfilePhoto ? 'Change Photo' : 'Upload Photo' }}
						</button>
						<ng-template [ngIf]="showCropModal">
							<app-crop-profile-picture (cropComplete)="cropComplete($event)"></app-crop-profile-picture>
						</ng-template>
					</div>

					<div *ngIf="userDetail?.enumeratedByName" class="meta-item text-end">
						<span class="meta-label">Enumerated By</span>
						<span class="meta-value">
							{{ userDetail?.displayname == userDetail?.enumeratedByName ? 'Self Enumerated' : (userDetail?.enumeratedByName | titlecase) }}
						</span>
					</div>

					<div class="meta-item text-end">
						<span class="meta-label">Registered</span>
						<span class="meta-value">{{ userDetail?.timeCreated | dateonly }}</span>
					</div>
				</div>
			</div>

			<!-- ── Tabs ── -->
			<div class="tabs-wrap">
			<div class="my-4">
				<div class="d-flex align-items-center gap-2">
				<button
					type="button"
					class="btn btn-outline-secondary btn-sm flex-shrink-0"
					(click)="navigateTab(-1)"
					[disabled]="isFirstTab"
					aria-label="Previous tab"
				>
					<span class="iconify" data-icon="lucide:step-back"></span>
				</button>

				<div class="tab-scroller flex-grow-1">
				<ul
					ngbNav
					#nav="ngbNav"
					[(activeId)]="activeId"
					(activeIdChange)="onActiveTabChange($event)"
					class="nav-tabs flex-nowrap"
				>
					<li ngbNavItem>
						<a ngbNavLink>Personal Information</a>

						<ng-template ngbNavContent>
							<form
								[formGroup]="editCompanyForm"
								*ngIf="
									userDetail?.taxgroup == 'COMPANY' ||
									userDetail?.taxgroup == 'INFORMAL'
								"
							>
								<div class="row personal-form">
									<div class="col-md-4">
										<div class="form-group mb-2">
											<label
												>Company Name
												<span class="text-danger"
													>*</span
												></label
											>
											<input
												formControlName="corporateName"
												type="text"
												class="form-control readonly-input"
												placeholder="Company Name"
												readonly
											/>
										</div>
										<div class="row">
											<div class="col-md-12">
												<div class="form-group mb-2">
													<label
														>Address
														<span
															class="text-danger"
															>*</span
														></label
													>
													<input
														formControlName="address"
														type="text"
														class="form-control readonly-input"
														placeholder="5, xxxxx, Estate..."
														readonly
													/>
												</div>
												<div class="form-group mb-2">
													<label
														>Nature of
														Business</label
													>
													<select
														class="form-control"
														formControlName="natureOfBusiness"
													>
														<option default>
															{{
																companyDetails?.natureOfBusiness
															}}
														</option>
													</select>
												</div>
											</div>
										</div>
									</div>

									<div class="col-md-4">
										<div class="col-md-12">
											<div class="form-group mb-2">
												<label
													>Email
													<span class="text-danger"
														>*</span
													></label
												>
												<input
													formControlName="email"
													type="email"
													class="form-control"
													placeholder="axxxxx@gmail.com"
													readonly
												/>
											</div>
										</div>

										<div class="form-group mb-2">
											<label>RC. Number</label>
											<input
												formControlName="rcNumber"
												type="text"
												class="form-control readonly-input"
												placeholder="32xxxxx"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label>Classification</label>
											<select
												class="form-control"
												formControlName="classification"
											>
												<option default>
													{{
														companyDetails?.classification
													}}
												</option>
												<!-- <option value="BUSINESS_NAME">Business Name</option>
													<option value="COMPANY">Company</option>
													<option value="INCORPORATED_TRUSTEE">Incorporated Trustee</option>
													<option value="LIMITED_PARTNERSHIP">Limited Partnership</option>
													<option value="LIMITED_LIABILITY_PARTNERSHIP">Limited Liability
														Partnership</option> -->
											</select>
										</div>
									</div>

									<div class="col-md-4">
										<div class="form-group mb-2">
											<label
												>Mobile Number
												<span class="text-danger"
													>*</span
												></label
											>
											<input
												formControlName="phoneNumber"
												type="text"
												class="form-control readonly-input"
												placeholder="Mobile Number"
												readonly
											/>
										</div>
										<div class="form-group mb-2">
											<label>LGA</label>
											<input
												type="text"
												class="form-control"
												[value]="
													companyDetails?.lgaName
												"
											/>
										</div>
										<div class="form-group mb-2">
											<label
												>TIN
												<span class="text-danger"
													>*</span
												></label
											>
											<input
												formControlName="tin"
												type="text"
												class="form-control readonly-input"
												placeholder="32xxxxxxxxxxx"
												readonly
											/>
										</div>
									</div>
								</div>
							</form>

							<!-- non company starts here -->
							<form
								class="cust-width"
								*ngIf="
									userDetail?.taxgroup != 'COMPANY' &&
									userDetail?.taxgroup != 'INFORMAL'
								"
								[formGroup]="editNonCompanyForm"
							>
								<div class="row personal-form">
									<div class="col-md-4">
										<div class="form-group mb-2">
											<label
												>First Name
												<span class="text-danger"
													>*</span
												></label
											>
											<input
												formControlName="firstName"
												type="text"
												class="form-control readonly-input"
												placeholder="First Name"
												readonly
											/>
										</div>
										<div class="row">
											<div class="col-md-12">
												<div class="form-group mb-2">
													<label>Gender</label>
													<select
														class="form-control"
														formControlName="gender"
													>
														<option default>
															{{
																userDetails?.gender
																	| uppercase
															}}
														</option>
														<!-- <option value="MALE">Male</option>
															<option value="FEMALE">Female</option> -->
													</select>
												</div>
											</div>
											<div class="col-md-12">
												<div class="form-group mb-2">
													<label>Date of Birth</label>
													<input
														formControlName="dob"
														type="date"
														class="form-control readonly-input"
														readonly
													/>
												</div>
											</div>
										</div>
										<div class="form-group mb-2">
											<label>LGA</label>
											<input
												type="text"
												class="form-control"
												[value]="userDetail?.lgaName"
											/>
										</div>
									</div>

									<div class="col-md-4">
										<div class="form-group mb-2">
											<label
												>Last Name
												<span class="text-danger"
													>*</span
												></label
											>
											<input
												formControlName="lastName"
												type="text"
												class="form-control readonly-input"
												placeholder="Last name"
												readonly
											/>
										</div>
										<div class="form-group mb-2">
											<label
												>Mobile Number
												<span class="text-danger"
													>*</span
												></label
											>
											<input
												formControlName="phoneNumber"
												type="text"
												class="form-control readonly-input"
												placeholder="Mobile Number"
												readonly
											/>
										</div>
										<div class="form-group mb-2">
											<label>NIN</label>
											<input
												formControlName="nin"
												type="text"
												class="form-control readonly-input"
												placeholder="32xxxxxxxxxxx"
												readonly
											/>
										</div>
										<div class="form-group mb-2">
											<label>Occupation</label>
											<input
												type="text"
												class="form-control"
												[value]="
													userDetails?.occupation ||
													''
												"
											/>
										</div>
									</div>

									<div class="col-md-4">
										<div class="form-group mb-2">
											<label
												>Tax Payer’s ASIN
												<span class="text-danger"
													>*</span
												></label
											>
											<input
												formControlName="tin"
												type="text"
												class="form-control readonly-input"
												placeholder="32xxxxxxxxxxx"
												readonly
											/>
										</div>
										<div class="form-group mb-2">
											<label
												>Email Address
												<span class="text-danger"
													>*</span
												></label
											>
											<input
												formControlName="email"
												type="email"
												class="form-control readonly-input"
												placeholder="axxxxx@gmail.com"
												readonly
											/>
										</div>
										<div class="form-group mb-2">
											<label>Marital Status</label>
											<input
												type="text"
												class="form-control"
												[value]="
													userDetails?.maritalStatus
												"
											/>
										</div>
										<div class="form-group mb-2">
											<label
												>Residential Address
												<span class="text-danger"
													>*</span
												></label
											>
											<input
												formControlName="address"
												type="text"
												class="form-control readonly-input"
												placeholder="5, xxxxx, Estate..."
												readonly
											/>
										</div>
									</div>
								</div>
							</form>
							<!-- <div class="top-border other-width d-flex justify-content-end">
									<button
										*ngIf="userDetail?.taxgroup != 'COMPANY' && userDetail?.taxgroup != 'INFORMAL'"
										type="submit" class="btn btn-sm btn-outline-dark custom-button-style"
										[disabled]="!editNonCompanyForm.valid" (click)="confirmEdit()">
										Update Information
									</button>
									<button
										*ngIf="userDetail?.taxgroup == 'COMPANY' || userDetail?.taxgroup == 'INFORMAL'"
										type="submit" class="btn btn-sm btn-outline-dark custom-button-style"
										[disabled]="!editCompanyForm.valid" (click)="confirmCompanyEdit()">
										Update Information
									</button>
								</div> -->

							<div class="w-100 d-flex justify-content-end mt-4">
								<button
									*ngIf="hasAccess(['ALL_PERMISSIONS','CAN_EDIT_TAXPAYER_PROFILE'])"
									class="edit-action-btn"
									(click)="editPersonalInformation()"
								>
									<span class="material-icons" style="font-size:14px">edit</span> Edit Info
								</button>
							</div>
						</ng-template>
					</li>

					<li
						ngbNavItem
						*ngIf="userDetail?.taxgroup == 'USER'"
					>
						<a ngbNavLink>Other Personal Information</a>

						<ng-template ngbNavContent>
							<form
								class="cust-width"
								[formGroup]="form"
							>
								<div class="row personal-form mb-3">
									<div class="col">
										<div class="form-group mb-2">
											<label>Income Category</label>
											<input
												type="text"
												formControlName="incomeCategory"
												class="form-select"
												readonly
											/>
										</div>
									</div>

									<div
										class="col"
										[class.d-none]="
											form.get('incomeCategory')
												?.value !== 'EMPLOYED'
										"
									>
										<div class="form-group mb-2">
											<label>Name Of Employer</label>
											<input
												type="text"
												class="form-control"
												formControlName="employerName"
												placeholder="Enter Employer Name"
												readonly
											/>
										</div>
									</div>

									<div
										class="col"
										[class.d-none]="
											form.get('incomeCategory')
												?.value !== 'EMPLOYED'
										"
									>
										<div class="form-group mb-2">
											<label
												>Income/Salary Range Per
												Annum</label
											>
											<input
												class="form-control"
												formControlName="incomeRange"
												readonly
											/>
										</div>
									</div>
								</div>

								<div
									class="row personal-form mb-3"
									[class.d-none]="
										form.get('incomeCategory')?.value !=
										'SELF EMPLOYED'
									"
								>
									<div class="col">
										<div class="form-group mb-2">
											<label>Industry</label>
											<input
												type="text"
												class="form-control"
												formControlName="natureOfBusiness"
												readonly
											/>
										</div>
									</div>
									<div
										class="col"
										[class.d-none]="
											form.get('incomeCategory')?.value !=
												'SELF EMPLOYED' ||
											form.get('incomeCategory')?.value !=
												'UNEMPLOYED'
										"
									>
										<div class="form-group mb-2">
											<label>Source Of Income</label>
											<input
												class="form-control"
												formControlName="sourceOfIncome"
												readonly
											/>
										</div>
									</div>
									<div
										class="col"
										[class.d-none]="
											form.get('incomeCategory')?.value !=
												'SELF EMPLOYED' ||
											form.get('incomeCategory')?.value !=
												'UNEMPLOYED'
										"
									>
										<div class="form-group mb-2">
											<label
												>Total Annual Income(₦)</label
											>
											<input
												class="form-control"
												formControlName="totalAnnualIncome"
												type="text"
												readonly
											/>
										</div>
									</div>
								</div>

								<div class="row personal-form mb-3">
									<div class="col">
										<div class="form-group mb-2">
											<label
												>Highest Level of
												Education</label
											><br />
											<input
												type="text"
												class="form-control"
												formControlName="educationLevel"
												readonly
											/>
										</div>
									</div>
								</div>

								<div class="row personal-form mb-3">
									<div class="col">
										<div class="form-group mb-2">
											<label>State of Origin</label>
											<input
												type="text"
												class="form-control"
												formControlName="stateOfOrigin"
												readonly
											/>
										</div>
									</div>

									<div class="col">
										<div class="form-group mb-2">
											<label>LGA of Origin</label>
											<input
												type="text"
												class="form-control"
												formControlName="lgaOfOrigin"
												readonly
											/>
										</div>
									</div>

									<div class="col">
										<div class="form-group mb-2">
											<label>Nearest Landmark</label>
											<input
												type="text"
												class="form-control"
												placeholder="Enter Nearest landmark"
												formControlName="landMark"
												readonly
											/>
										</div>
									</div>
								</div>

								<div class="row personal-form mb-3">
									<div class="col">
										<div class="form-group mb-2">
											<label>Accommodation Type</label>
											<input
												type="text"
												formControlName="accommodationType"
												class="form-select"
												readonly
											/>
										</div>
									</div>
									<div
										class="col"
										[class.d-none]="
											form?.get('accommodationType')
												?.value != 'owned'
										"
									>
										<div class="form-group mb-2">
											<label>Building Type</label>
											<input
												type="text"
												formControlName="buildingType"
												class="form-select"
												readonly
											/>
										</div>
									</div>
									<div
										class="col"
										[class.d-none]="
											!['rented', 'leased'].includes(
												form.get('accommodationType')
													.value
											)
										"
									>
										<div class="form-group mb-2">
											<label>Period Type</label>
											<input
												type="text"
												formControlName="periodType"
												class="form-select"
												readonly
											/>
										</div>
									</div>
								</div>

								<div class="row personal-form mb-3">
									<!-- <div
										class="col"
										[class.d-none]="
											![
												'bungalow',
												'duplex',
												'flat',
											].includes(
												form.get('buildingType').value
											)
										"
									>
										<div class="form-group mb-2">
											<label>No. of Rooms</label>
											<input
												type="text"
												class="form-select"
												formControlName="numberOfRooms"
												readonly
											/>
										</div>
									</div> -->
									<div
										class="col"
										[class.d-none]="
											!['rented', 'leased'].includes(
												form.get('accommodationType')
													.value
											)
										"
									>
										<div class="form-group mb-2">
											<label>Rent Period Covered</label>
											<input
												type="text"
												class="form-control"
												formControlName="rentPeriodCovered"
												readonly
											/>
										</div>
									</div>
									<div
										class="col"
										[class.d-none]="
											!['rented', 'leased'].includes(
												form.get('accommodationType')
													.value
											)
										"
									>
										<div class="form-group mb-2">
											<label>Rent Amount</label>
											<input
												type="text"
												class="form-control"
												formControlName="rentAmount"
												readonly
											/>
										</div>
									</div>
								</div>

								<div class="row personal-form mb-3">
									<div class="col">
										<div class="form-group mb-2">
											<label>LandLord Name</label>
											<input
												type="text"
												class="form-control"
												formControlName="landlordFullName"
												readonly
											/>
										</div>
									</div>

									<div class="col">
										<div class="form-group mb-2">
											<label>Landlord Phone Number</label>
											<input
												type="tel"
												class="form-control"
												formControlName="landlordPhoneNumber"
												readonly
											/>
										</div>
									</div>

									<div class="col">
										<div class="form-group mb-2">
											<label>Landlord ASIN</label>
											<input
												type="text"
												class="form-control"
												formControlName="landlordAsin"
												readonly
											/>
										</div>
									</div>
								</div>

								<div class="row personal-form mb-3">
									<div class="col">
										<div class="form-group mb-2">
											<label>Landlord Email </label>
											<input
												type="email"
												class="form-control"
												formControlName="landlordEmail"
												readonly
											/>
										</div>
									</div>
									<div class="col">
										<div class="form-group mb-2">
											<label
												>Does Landlord Live In Same
												Apartment?</label
											>
											<input
												type="text"
												formControlName="doesLandlordLiveSameApartment"
												class="form-select"
												readonly
											/>
										</div>
									</div>
									<div
										class="col"
										[class.d-none]="
											!form.get(
												'doesLandlordLiveSameApartment'
											)?.value
										"
									>
										<div class="form-group mb-2">
											<label>Landlord Address</label>
											<input
												type="text"
												class="form-control"
												formControlName="landlordAddress"
												placeholder="Enter Address"
											/>
										</div>
									</div>
								</div>

								<div class="row personal-form mb-3">
									<div class="col">
										<div class="form-group mb-2">
											<label
												>Do you have a vehicle?</label
											>
											<input
												type="text"
												formControlName="hasVehicle"
												class="form-select"
												readonly
											/>
										</div>
									</div>
									<div
										class="col"
										[class.d-none]="
											form.get('hasVehicle')?.value ==
											'YES'
										"
									>
										<div class="form-group mb-2">
											<label
												>How Many Vehicles Owned?</label
											>
											<input
												type="text"
												formControlName="numberOfVehicles"
												class="form-control"
												readonly
											/>
										</div>
									</div>
									<div class="col">
										<div class="form-group mb-2">
											<label
												>Do you have a property?</label
											>
											<input
												type="text"
												formControlName="hasProperty"
												class="form-control"
												readonly
											/>
										</div>
									</div>
								</div>

								<div class="row personal-form">
									<div
										class="col"
										[class.d-none]="
											form.get('hasProperty')?.value ==
											'YES'
										"
									>
										<div class="form-group mb-2">
											<label>Assets/Property Type</label>
											<input
												formControlName="propertyType"
												class="form-control"
												readonly
											/>
										</div>
									</div>
									<div class="col">
										<div class="form-group mb-2">
											<label>Do you own a Business</label>
											<input
												type="text"
												formControlName="hasBusiness"
												class="form-control"
												readonly
											/>
										</div>
									</div>
									<div class="col">
										<div class="form-group mb-2">
											<label
												>Do you own a Business
												Venture</label
											>
											<input
												type="text"
												formControlName="ownCompany"
												class="form-select"
												readonly
											/>
										</div>
									</div>
								</div>

								<div class="w-100 d-flex justify-content-end mt-4">
									<button
										*ngIf="hasAccess(['ALL_PERMISSIONS','CAN_EDIT_TAXPAYER_PROFILE'])"
										class="edit-action-btn"
										(click)="editOtherPersonalInformation()"
									>
										<span class="material-icons" style="font-size:14px">edit</span> Edit Info
										<svg
											width="60"
											height="30"
											viewBox="0 0 48 18"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<rect
												width="47.3455"
												height="17.7545"
												rx="1.69091"
												fill="#FAF8F2"
											/>
											<path
												d="M14.3578 5.16183L15.5516 6.35504M15.1255 4.11064L11.8975 7.33859C11.7307 7.50514 11.617 7.71734 11.5706 7.94844L11.2725 9.44095L12.765 9.14223C12.9961 9.09601 13.208 8.98272 13.3748 8.81588L16.6028 5.58794C16.6998 5.49094 16.7767 5.37578 16.8292 5.24904C16.8817 5.1223 16.9087 4.98647 16.9087 4.84929C16.9087 4.71211 16.8817 4.57627 16.8292 4.44954C16.7767 4.3228 16.6998 4.20764 16.6028 4.11064C16.5058 4.01364 16.3906 3.9367 16.2639 3.8842C16.1371 3.83171 16.0013 3.80469 15.8641 3.80469C15.7269 3.80469 15.5911 3.83171 15.4644 3.8842C15.3376 3.9367 15.2225 4.01364 15.1255 4.11064Z"
												stroke="#896A00"
												stroke-width="0.845454"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M15.7817 10.5681V12.259C15.7817 12.558 15.6629 12.8447 15.4515 13.0561C15.2401 13.2675 14.9534 13.3863 14.6544 13.3863H8.45442C8.15545 13.3863 7.86872 13.2675 7.65732 13.0561C7.44591 12.8447 7.32715 12.558 7.32715 12.259V6.05904C7.32715 5.76006 7.44591 5.47334 7.65732 5.26193C7.86872 5.05053 8.15545 4.93176 8.45442 4.93176H10.1453"
												stroke="#896A00"
												stroke-width="0.845454"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M23.7552 12.3773V4.99881H28.3812V5.95715H24.8685V8.20529H28.1398V9.16003H24.8685V11.419H28.4244V12.3773H23.7552ZM31.8534 12.4854C31.4066 12.4854 31.0079 12.3713 30.6573 12.1431C30.309 11.9126 30.0352 11.5847 29.8358 11.1596C29.6389 10.732 29.5404 10.2192 29.5404 9.62119C29.5404 9.02312 29.6401 8.51153 29.8394 8.0864C30.0412 7.66127 30.3174 7.33582 30.6681 7.11004C31.0187 6.88427 31.4162 6.77138 31.8606 6.77138C32.2041 6.77138 32.4803 6.82902 32.6892 6.94431C32.9006 7.0572 33.0639 7.1893 33.1792 7.34062C33.2969 7.49194 33.3882 7.62524 33.453 7.74053H33.5179V4.99881H34.5951V12.3773H33.5431V11.5163H33.453C33.3882 11.6339 33.2945 11.7684 33.172 11.9198C33.0519 12.0711 32.8862 12.2032 32.6748 12.3161C32.4635 12.429 32.1896 12.4854 31.8534 12.4854ZM32.0912 11.5667C32.401 11.5667 32.6628 11.485 32.8766 11.3217C33.0927 11.156 33.2561 10.9266 33.3666 10.6336C33.4794 10.3405 33.5359 9.99948 33.5359 9.61038C33.5359 9.22608 33.4806 8.88982 33.3702 8.6016C33.2597 8.31337 33.0975 8.0888 32.8838 7.92788C32.67 7.76695 32.4058 7.68649 32.0912 7.68649C31.7669 7.68649 31.4967 7.77055 31.2805 7.93868C31.0644 8.10681 30.901 8.33619 30.7906 8.62682C30.6825 8.91744 30.6284 9.24529 30.6284 9.61038C30.6284 9.98026 30.6837 10.3129 30.7942 10.6083C30.9046 10.9038 31.068 11.138 31.2841 11.3109C31.5027 11.4814 31.7717 11.5667 32.0912 11.5667ZM36.1326 12.3773V6.84344H37.2098V12.3773H36.1326ZM36.6766 5.98957C36.4893 5.98957 36.3283 5.92713 36.1938 5.80223C36.0617 5.67493 35.9957 5.52361 35.9957 5.34828C35.9957 5.17054 36.0617 5.01922 36.1938 4.89433C36.3283 4.76703 36.4893 4.70338 36.6766 4.70338C36.864 4.70338 37.0237 4.76703 37.1558 4.89433C37.2903 5.01922 37.3575 5.17054 37.3575 5.34828C37.3575 5.52361 37.2903 5.67493 37.1558 5.80223C37.0237 5.92713 36.864 5.98957 36.6766 5.98957ZM41.2423 6.84344V7.7081H38.2195V6.84344H41.2423ZM39.0301 5.51761H40.1074V10.7525C40.1074 10.9614 40.1386 11.1187 40.201 11.2244C40.2635 11.3277 40.344 11.3986 40.4424 11.437C40.5433 11.473 40.6526 11.491 40.7703 11.491C40.8568 11.491 40.9324 11.485 40.9973 11.473C41.0621 11.461 41.1125 11.4514 41.1486 11.4442L41.3431 12.3341C41.2807 12.3581 41.1918 12.3821 41.0765 12.4061C40.9612 12.4326 40.8171 12.447 40.6442 12.4494C40.3608 12.4542 40.0966 12.4037 39.8516 12.2981C39.6066 12.1924 39.4084 12.029 39.2571 11.8081C39.1058 11.5871 39.0301 11.3097 39.0301 10.9758V5.51761Z"
												fill="#896A00"
											/>
										</svg>
									</button>
								</div>
							</form>
						</ng-template>
					</li>

					<li ngbNavItem>
						<a
							ngbNavLink
							(click)="
								getLatestTransaction(); getAllTransactions()
							"
							>Transaction History</a
						>

						<ng-template ngbNavContent>
							<div class="cust-width">
								<div class="row">
									<table>
										<thead>
											<tr>
												<th
													class="text-center cust-th-border-left"
												>
													<svg
														class="me-2"
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
													>
														<g
															clip-path="url(#clip0_30_652)"
														>
															<mask
																id="mask0_30_652"
																style="
																	mask-type: luminance;
																"
																maskUnits="userSpaceOnUse"
																x="0"
																y="0"
																width="24"
																height="24"
															>
																<path
																	d="M12 22C13.3135 22.0017 14.6143 21.7438 15.8278 21.2412C17.0413 20.7385 18.1435 20.001 19.071 19.071C20.001 18.1435 20.7385 17.0413 21.2412 15.8278C21.7438 14.6143 22.0017 13.3135 22 12C22.0017 10.6865 21.7438 9.3857 21.2411 8.17222C20.7385 6.95875 20.001 5.85656 19.071 4.92901C18.1435 3.99902 17.0413 3.26151 15.8278 2.75885C14.6143 2.25619 13.3135 1.99831 12 2.00001C10.6865 1.99833 9.3857 2.25623 8.17222 2.75889C6.95875 3.26154 5.85656 3.99904 4.92901 4.92901C3.99904 5.85656 3.26154 6.95875 2.75889 8.17222C2.25623 9.3857 1.99833 10.6865 2.00001 12C1.99831 13.3135 2.25619 14.6143 2.75885 15.8278C3.26151 17.0413 3.99902 18.1435 4.92901 19.071C5.85656 20.001 6.95875 20.7385 8.17222 21.2411C9.3857 21.7438 10.6865 22.0017 12 22Z"
																	fill="white"
																	stroke="white"
																	stroke-width="4"
																	stroke-linejoin="round"
																/>
																<path
																	d="M8 12L11 15L17 9"
																	stroke="black"
																	stroke-linecap="round"
																	stroke-linejoin="round"
																/>
															</mask>
															<g
																mask="url(#mask0_30_652)"
															>
																<path
																	d="M0 0H24V24H0V0Z"
																	fill="#11A805"
																/>
															</g>
														</g>
														<defs>
															<clipPath
																id="clip0_30_652"
															>
																<rect
																	width="24"
																	height="24"
																	fill="white"
																/>
															</clipPath>
														</defs>
													</svg>
													<strong
														class="trans-hist-header"
														>Recent
														Transaction</strong
													>
												</th>
												<th
													class="text-center cust-th-border-right"
												>
													<svg
														class="me-2"
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
													>
														<g
															clip-path="url(#clip0_30_659)"
														>
															<path
																d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM6 13.8C5.004 13.8 4.2 12.996 4.2 12C4.2 11.004 5.004 10.2 6 10.2C6.996 10.2 7.8 11.004 7.8 12C7.8 12.996 6.996 13.8 6 13.8ZM12 13.8C11.004 13.8 10.2 12.996 10.2 12C10.2 11.004 11.004 10.2 12 10.2C12.996 10.2 13.8 11.004 13.8 12C13.8 12.996 12.996 13.8 12 13.8ZM18 13.8C17.004 13.8 16.2 12.996 16.2 12C16.2 11.004 17.004 10.2 18 10.2C18.996 10.2 19.8 11.004 19.8 12C19.8 12.996 18.996 13.8 18 13.8Z"
																fill="#F0CE62"
															/>
														</g>
														<defs>
															<clipPath
																id="clip0_30_659"
															>
																<rect
																	width="24"
																	height="24"
																	fill="white"
																/>
															</clipPath>
														</defs>
													</svg>
													<strong
														class="trans-hist-header"
														>Approved
														Transactions</strong
													>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td
													class="cust-td-border-left"
													*ngIf="latestTransaction"
												>
													<div
														class="row"
														style="
															padding: 30px 30px
																4px 30px !important;
														"
													>
														<div class="col-md-6">
															<div
																class="form-group mb-2"
																style="
																	text-align: right;
																"
															>
																<h6>
																	Reference
																	ID:
																</h6>
																<p>
																	<small>{{
																		latestTransaction?.rrr
																	}}</small>
																</p>
															</div>
														</div>
														<div class="col-md-6">
															<div
																class="form-group mb-2"
																style="
																	text-align: left;
																"
															>
																<h6>
																	Transaction
																	Date:
																</h6>
																<p>
																	<small>{{
																		latestTransaction?.paymentDate
																			| datetime
																	}}</small>
																</p>
															</div>
														</div>
													</div>
													<div
														class="row"
														style="
															padding: 4px 30px
																30px 30px !important;
														"
													>
														<div class="col-md-6">
															<div
																class="form-group mb-2"
																style="
																	text-align: right;
																"
															>
																<h6>Amount:</h6>
																<br />
																<b>
																	<small>{{
																		latestTransaction?.amount
																			| nairaCurrency
																	}}</small>
																</b>
															</div>
														</div>
														<div class="col-md-6">
															<div
																class="form-group mb-2"
																style="
																	text-align: left;
																"
															>
																<h6>
																	Description:
																</h6>
																<p>
																	<small>{{
																		latestTransaction?.feeDescription
																			| titlecase
																	}}</small>
																</p>
															</div>
														</div>
													</div>
												</td>

												<td
													class="cust-td-border-left"
													*ngIf="!latestTransaction"
												>
													<div
														class="row p-4 app-center"
													>
														<p class="text-center">
															No Transaction
														</p>
														<div
															class="text-center mt-3"
														>
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="96"
																height="96"
																viewBox="0 0 96 96"
																fill="none"
															>
																<path
																	d="M74 16H22C19.7909 16 18 17.7909 18 20V84C18 86.2091 19.7909 88 22 88H74C76.2091 88 78 86.2091 78 84V20C78 17.7909 76.2091 16 74 16Z"
																	stroke="#686988"
																	stroke-width="2"
																	stroke-linejoin="round"
																/>
																<path
																	d="M36 8V20M60 8V20M32 38H64M36 54H60M39.5 70H55.5"
																	stroke="#686988"
																	stroke-width="2"
																	stroke-linecap="round"
																	stroke-linejoin="round"
																/>
															</svg>
														</div>
													</div>
												</td>

												<td
													class="cust-td-border-right"
												>
													<div class="cust-width">
														<table
															class="table table-striped table-hover"
														>
															<thead
																*ngIf="
																	!transactionIsSearching &&
																	transactions?.length >
																		0
																"
															>
																<tr>
																	<th
																		scope="col"
																	>
																		S/N
																	</th>
																	<th>
																		Fee
																		Description
																	</th>
																	<th>
																		Revenue
																		Code
																	</th>
																	<th>
																		Amount
																	</th>
																	<th>
																		Payment
																		Date
																	</th>
																</tr>
															</thead>

															<tbody
																*ngIf="
																	!transactionIsSearching &&
																	transactions?.length >
																		0
																"
															>
																<tr
																	*ngFor="
																		let eachDetail of transactions;
																		let i = index
																	"
																>
																	<td
																		class="table-data"
																	>
																		{{
																			i +
																				transactionNum +
																				1
																		}}
																	</td>
																	<td
																		class="table-data"
																	>
																		{{
																			eachDetail?.feeDescription
																				| titlecase
																		}}
																	</td>
																	<td
																		class="table-data"
																	>
																		{{
																			eachDetail?.revenueCode
																				| uppercase
																		}}
																	</td>
																	<td
																		class="table-data"
																	>
																		{{
																			eachDetail?.amount
																				| nairaCurrency
																		}}
																	</td>
																	<td
																		class="table-data"
																	>
																		{{
																			eachDetail?.paymentDate
																				| datetime
																		}}
																	</td>
																</tr>
															</tbody>
														</table>

														<div
															class="pagination justify-content-end"
														>
															<ngb-pagination
																*ngIf="
																	!transactionIsSearching &&
																	transactions?.length >
																		0
																"
																class="d-flex justify-content-center my-3"
																[(page)]="
																	transactionCurrentPage
																"
																(pageChange)="
																	callTranscationsDb(
																		$event
																	)
																"
																[maxSize]="5"
																[pageSize]="
																	transactionPageSize
																"
																[collectionSize]="
																	transactionCount
																"
																[boundaryLinks]="
																	true
																"
																[directionLinks]="
																	true
																"
																[rotate]="true"
															></ngb-pagination>
														</div>

														<div
															*ngIf="
																transactions?.length <
																1
															"
															class="text-center"
														>
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="96"
																height="96"
																viewBox="0 0 96 96"
																fill="none"
															>
																<path
																	d="M74 16H22C19.7909 16 18 17.7909 18 20V84C18 86.2091 19.7909 88 22 88H74C76.2091 88 78 86.2091 78 84V20C78 17.7909 76.2091 16 74 16Z"
																	stroke="#686988"
																	stroke-width="2"
																	stroke-linejoin="round"
																/>
																<path
																	d="M32 38H64M36 54H60M39.5 70H55.5"
																	stroke="#686988"
																	stroke-width="2"
																	stroke-linecap="round"
																	stroke-linejoin="round"
																/>
															</svg>
															<p>
																No
																ApprovedTransaction
															</p>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</ng-template>
					</li>

					<li ngbNavItem>
						<a ngbNavLink>Other Information</a>

						<ng-template ngbNavContent>
							<form
								class="cust-width"
								[formGroup]="companyEnumerationForm"
							>
								<div class="row personal-form">
									<!-- COLUMN 1 -->
									<div class="col-md-4">
										<div class="form-group mb-2">
											<label>Number of Employees</label>
											<input
												formControlName="numberOfEmployees"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label>Number of Branches</label>
											<input
												formControlName="numberOfBranches"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label>Number of Vehicles</label>
											<input
												formControlName="vehicleCount"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label
												>Business Contact First
												Name</label
											>
											<input
												formControlName="businessContactFirstName"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label>Closest Tax Office</label>
											<input
												formControlName="closestTaxOffice"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>
									</div>

									<!-- COLUMN 2 -->
									<div class="col-md-4">
										<div class="form-group mb-2">
											<label>Ownership Type</label>
											<input
												formControlName="ownershipType"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label>Estimated Revenue</label>
											<input
												formControlName="estimatedRevenue"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label>Number of Properties</label>
											<input
												formControlName="corporatePropertyCount"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label
												>Business Contact Last
												Name</label
											>
											<input
												formControlName="businessContactLastName"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label>JTB TIN</label>
											<input
												formControlName="jtbTin"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>
									</div>

									<!-- COLUMN 3 -->
									<div class="col-md-4">
										<div class="form-group mb-2">
											<label>Average Staff Salary</label>
											<input
												formControlName="averageStaffSalary"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label>Number of Assets</label>
											<input
												formControlName="corporateAssetCount"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label
												>Business Contact Email</label
											>
											<input
												formControlName="businessContactEmail"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>

										<div class="form-group mb-2">
											<label
												>Business Contact Phone
												Number</label
											>
											<input
												formControlName="businessContactPhoneNumber"
												type="text"
												class="form-control readonly-input"
												readonly
											/>
										</div>
									</div>
								</div>
							</form>
						</ng-template>
					</li>

					<li ngbNavItem>
						<a ngbNavLink> Tax/Non-Tax Profile </a>

						<ng-template ngbNavContent>
							<div class="cust-width">
								<table class="table">
									<thead>
										<tr>
											<th>Type</th>
											<th>Category</th>
											<th>Sub Type</th>
											<th>Amount</th>
											<th>Action</th>
										</tr>
									</thead>

									<tbody
										*ngIf="
											!isSaving && profiles?.length > 0
										"
									>
										<tr
											*ngFor="
												let eachProfile of profiles;
												let i = index
											"
										>
											<td>
												{{
													eachProfile?.assessmentType
														| removeUnderscores
												}}
											</td>
											<td>
												{{
													eachProfile?.category
														| lowercase
												}}
											</td>
											<td>
												{{
													eachProfile?.incomeType ||
														"n/a"
												}}
											</td>
											<td>
												{{
													eachProfile?.amount
														| nairaCurrency
												}}
											</td>
											<td>
												<button
													class="btn btn-sm btn-outline-dark custom-button-style small-button"
													(click)="
														remove(eachProfile?.id)
													"
												>
													Remove
												</button>
											</td>
										</tr>
									</tbody>
								</table>

								<div
									*ngIf="profiles?.length < 1"
									class="text-center"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="96"
										height="96"
										viewBox="0 0 96 96"
										fill="none"
									>
										<path
											d="M74 16H22C19.7909 16 18 17.7909 18 20V84C18 86.2091 19.7909 88 22 88H74C76.2091 88 78 86.2091 78 84V20C78 17.7909 76.2091 16 74 16Z"
											stroke="#686988"
											stroke-width="2"
											stroke-linejoin="round"
										/>
										<path
											d="M32 38H64M36 54H60M39.5 70H55.5"
											stroke="#686988"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
									<p>No Data</p>
								</div>
							</div>

							<div class="w-100 d-flex justify-content-end mt-4">
								<button
									*ngIf="hasAccess(['ALL_PERMISSIONS','CAN_PROFILE_TAXPAYER'])"
									class="edit-action-btn"
									(click)="newProfiling()"
								>
									<span class="material-icons" style="font-size:14px">add</span> New Profiling
									<svg
										width="60"
										height="30"
										viewBox="0 0 48 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<rect
											width="47.3455"
											height="17.7545"
											rx="1.69091"
											fill="#FAF8F2"
										/>
										<path
											d="M14.3578 5.16183L15.5516 6.35504M15.1255 4.11064L11.8975 7.33859C11.7307 7.50514 11.617 7.71734 11.5706 7.94844L11.2725 9.44095L12.765 9.14223C12.9961 9.09601 13.208 8.98272 13.3748 8.81588L16.6028 5.58794C16.6998 5.49094 16.7767 5.37578 16.8292 5.24904C16.8817 5.1223 16.9087 4.98647 16.9087 4.84929C16.9087 4.71211 16.8817 4.57627 16.8292 4.44954C16.7767 4.3228 16.6998 4.20764 16.6028 4.11064C16.5058 4.01364 16.3906 3.9367 16.2639 3.8842C16.1371 3.83171 16.0013 3.80469 15.8641 3.80469C15.7269 3.80469 15.5911 3.83171 15.4644 3.8842C15.3376 3.9367 15.2225 4.01364 15.1255 4.11064Z"
											stroke="#896A00"
											stroke-width="0.845454"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M15.7817 10.5681V12.259C15.7817 12.558 15.6629 12.8447 15.4515 13.0561C15.2401 13.2675 14.9534 13.3863 14.6544 13.3863H8.45442C8.15545 13.3863 7.86872 13.2675 7.65732 13.0561C7.44591 12.8447 7.32715 12.558 7.32715 12.259V6.05904C7.32715 5.76006 7.44591 5.47334 7.65732 5.26193C7.86872 5.05053 8.15545 4.93176 8.45442 4.93176H10.1453"
											stroke="#896A00"
											stroke-width="0.845454"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M23.7552 12.3773V4.99881H28.3812V5.95715H24.8685V8.20529H28.1398V9.16003H24.8685V11.419H28.4244V12.3773H23.7552ZM31.8534 12.4854C31.4066 12.4854 31.0079 12.3713 30.6573 12.1431C30.309 11.9126 30.0352 11.5847 29.8358 11.1596C29.6389 10.732 29.5404 10.2192 29.5404 9.62119C29.5404 9.02312 29.6401 8.51153 29.8394 8.0864C30.0412 7.66127 30.3174 7.33582 30.6681 7.11004C31.0187 6.88427 31.4162 6.77138 31.8606 6.77138C32.2041 6.77138 32.4803 6.82902 32.6892 6.94431C32.9006 7.0572 33.0639 7.1893 33.1792 7.34062C33.2969 7.49194 33.3882 7.62524 33.453 7.74053H33.5179V4.99881H34.5951V12.3773H33.5431V11.5163H33.453C33.3882 11.6339 33.2945 11.7684 33.172 11.9198C33.0519 12.0711 32.8862 12.2032 32.6748 12.3161C32.4635 12.429 32.1896 12.4854 31.8534 12.4854ZM32.0912 11.5667C32.401 11.5667 32.6628 11.485 32.8766 11.3217C33.0927 11.156 33.2561 10.9266 33.3666 10.6336C33.4794 10.3405 33.5359 9.99948 33.5359 9.61038C33.5359 9.22608 33.4806 8.88982 33.3702 8.6016C33.2597 8.31337 33.0975 8.0888 32.8838 7.92788C32.67 7.76695 32.4058 7.68649 32.0912 7.68649C31.7669 7.68649 31.4967 7.77055 31.2805 7.93868C31.0644 8.10681 30.901 8.33619 30.7906 8.62682C30.6825 8.91744 30.6284 9.24529 30.6284 9.61038C30.6284 9.98026 30.6837 10.3129 30.7942 10.6083C30.9046 10.9038 31.068 11.138 31.2841 11.3109C31.5027 11.4814 31.7717 11.5667 32.0912 11.5667ZM36.1326 12.3773V6.84344H37.2098V12.3773H36.1326ZM36.6766 5.98957C36.4893 5.98957 36.3283 5.92713 36.1938 5.80223C36.0617 5.67493 35.9957 5.52361 35.9957 5.34828C35.9957 5.17054 36.0617 5.01922 36.1938 4.89433C36.3283 4.76703 36.4893 4.70338 36.6766 4.70338C36.864 4.70338 37.0237 4.76703 37.1558 4.89433C37.2903 5.01922 37.3575 5.17054 37.3575 5.34828C37.3575 5.52361 37.2903 5.67493 37.1558 5.80223C37.0237 5.92713 36.864 5.98957 36.6766 5.98957ZM41.2423 6.84344V7.7081H38.2195V6.84344H41.2423ZM39.0301 5.51761H40.1074V10.7525C40.1074 10.9614 40.1386 11.1187 40.201 11.2244C40.2635 11.3277 40.344 11.3986 40.4424 11.437C40.5433 11.473 40.6526 11.491 40.7703 11.491C40.8568 11.491 40.9324 11.485 40.9973 11.473C41.0621 11.461 41.1125 11.4514 41.1486 11.4442L41.3431 12.3341C41.2807 12.3581 41.1918 12.3821 41.0765 12.4061C40.9612 12.4326 40.8171 12.447 40.6442 12.4494C40.3608 12.4542 40.0966 12.4037 39.8516 12.2981C39.6066 12.1924 39.4084 12.029 39.2571 11.8081C39.1058 11.5871 39.0301 11.3097 39.0301 10.9758V5.51761Z"
											fill="#896A00"
										/>
									</svg>
								</button>
							</div>
						</ng-template>
					</li>

					<li ngbNavItem>
						<a ngbNavLink>Assessments</a>

						<ng-template ngbNavContent>
							<div class="cust-width table-container">
								<table class="table">
									<thead>
										<tr>
											<th>S/N</th>
											<th>Assessed By</th>
											<th>AIRMS ID</th>
											<th>Assess. Year</th>
											<th>Category</th>
											<th>Amount</th>
											<th>Payment Status</th>
											<th>Approval Status</th>
										</tr>
									</thead>

									<tbody *ngIf="assessments?.length > 0">
										<tr
											*ngFor="
												let eachDetail of assessments;
												let i = index
											"
										>
											<td>{{ i + 1 }}</td>
											<td>
												{{
													eachDetail?.assessedBy
														| uppercase
												}}
											</td>
											<td>
												{{
													eachDetail?.assessmentId
														| uppercase
												}}
											</td>
											<td>
												{{ eachDetail?.assessmentYear }}
											</td>
											<td>
												{{
													eachDetail?.assessmentType
														| uppercase
														| removeUnderscores
												}}
											</td>
											<td>
												{{
													eachDetail?.amount
														| nairaCurrency
												}}
											</td>
											<td
												[ngClass]="{
													'not-paid':
														eachDetail?.paymentStatus ===
														'NOT_PAID',
													paid:
														eachDetail?.paymentStatus ===
														'PAID',
												}"
											>
												{{
													transformPaymentStatus(
														eachDetail?.paymentStatus
													)
												}}
											</td>
											<td>
												{{
													eachDetail?.approvalStatus
														| uppercase
												}}
											</td>
										</tr>
									</tbody>
								</table>

								<div
									*ngIf="assessments?.length < 1"
									class="text-center"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="96"
										height="96"
										viewBox="0 0 96 96"
										fill="none"
									>
										<path
											d="M74 16H22C19.7909 16 18 17.7909 18 20V84C18 86.2091 19.7909 88 22 88H74C76.2091 88 78 86.2091 78 84V20C78 17.7909 76.2091 16 74 16Z"
											stroke="#686988"
											stroke-width="2"
											stroke-linejoin="round"
										/>
										<path
											d="M32 38H64M36 54H60M39.5 70H55.5"
											stroke="#686988"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
									<p>No Assessment Data</p>
								</div>
							</div>
						</ng-template>
					</li>

					<li
						ngbNavItem
						*ngIf="hasAccess(['ALL_PERMISSIONS', 'CAN_VIEW_SHOPS'])"
					>
						<a
							ngbNavLink
							(click)="checkMarket()"
							>Market Shops Owned</a
						>

						<ng-template ngbNavContent>
							<div class="cust-width table-container">
								<table class="table">
									<thead>
										<tr>
											<th>S/N</th>
											<th>Market Name</th>
											<th>Mcode</th>
											<th>Line</th>
											<th>Shop Number</th>
											<th>Business Name</th>
											<th>Business Type</th>
											<th>Business Category</th>
											<th>Current Payment</th>
										</tr>
									</thead>

									<tbody *ngIf="marketList?.length > 0">
										<tr
											*ngFor="
												let eachDetail of marketList;
												let i = index
											"
										>
											<td>{{ i + 1 }}</td>
											<td>
												{{
													eachDetail?.market
														| uppercase
												}}
											</td>
											<td>
												{{
													eachDetail?.asin
														| uppercase
												}}
											</td>
											<td>
												{{
													eachDetail?.line | uppercase
												}}
											</td>
											<td>
												{{
													eachDetail?.shop | uppercase
												}}
											</td>
											<td>
												{{
													eachDetail?.busnessName
														| uppercase
												}}
											</td>
											<td>
												{{
													eachDetail?.businessType
														| uppercase
												}}
											</td>
											<td>
												{{
													eachDetail?.business
														| uppercase
												}}
											</td>
											<td>
												{{
													eachDetail?.rent || 0
														| nairaCurrency
												}}
											</td>
										</tr>
									</tbody>
								</table>

								<div
									*ngIf="marketList?.length < 1"
									class="text-center"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="96"
										height="96"
										viewBox="0 0 96 96"
										fill="none"
									>
										<path
											d="M74 16H22C19.7909 16 18 17.7909 18 20V84C18 86.2091 19.7909 88 22 88H74C76.2091 88 78 86.2091 78 84V20C78 17.7909 76.2091 16 74 16Z"
											stroke="#686988"
											stroke-width="2"
											stroke-linejoin="round"
										/>
										<path
											d="M32 38H64M36 54H60M39.5 70H55.5"
											stroke="#686988"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
									<p>No Market Shop Owned</p>
								</div>
							</div>
						</ng-template>
					</li>

					<li ngbNavItem>
						<a ngbNavLink>Withheld Taxes</a>

						<ng-template ngbNavContent>
							<div class="cust-width table-container">
								<table class="table">
									<thead>
										<tr>
											<th>S/N</th>
											<th>Application ID</th>
											<th>Withheld By</th>
											<th>Transaction Amount</th>
											<th>Transaction Date</th>
											<th>WHT Amount</th>
											<th>Payment Status</th>
										</tr>
									</thead>

									<tbody *ngIf="whtList?.length > 0">
										<tr
											*ngFor="
												let eachDetail of whtList;
												let i = index
											"
										>
											<td>{{ i + 1 }}</td>
											<td>
												{{
													eachDetail?.applicationId
														| uppercase
												}}
											</td>
											<td>
												{{
													eachDetail?.withHolderName
														| uppercase
												}}
											</td>
											<td>
												{{
													eachDetail?.transactionAmount
														| nairaCurrency
												}}
											</td>
											<td>
												{{
													eachDetail?.transactionDate
														| dateonly
												}}
											</td>
											<td>
												{{
													eachDetail?.totalTaxDue
														| nairaCurrency
												}}
											</td>
											<td>
												{{
													eachDetail?.paymentStatus
														| removeUnderscores
												}}
											</td>
										</tr>
									</tbody>
								</table>

								<div
									*ngIf="whtList?.length < 1"
									class="text-center"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="96"
										height="96"
										viewBox="0 0 96 96"
										fill="none"
									>
										<path
											d="M74 16H22C19.7909 16 18 17.7909 18 20V84C18 86.2091 19.7909 88 22 88H74C76.2091 88 78 86.2091 78 84V20C78 17.7909 76.2091 16 74 16Z"
											stroke="#686988"
											stroke-width="2"
											stroke-linejoin="round"
										/>
										<path
											d="M32 38H64M36 54H60M39.5 70H55.5"
											stroke="#686988"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
									<p>No WHT Data</p>
								</div>
							</div>
						</ng-template>
					</li>

					<li
						ngbNavItem
						id="ansaa-info"
					>
						<a ngbNavLink>ANSAA Information</a>
						<ng-template ngbNavContent>
							<app-ansaa-data-integration
								[userAsin]="userAsin"
								[userNIN]="userDetails?.nin"
							></app-ansaa-data-integration>
						</ng-template>
					</li>

					<li
						ngbNavItem
						id="ansaa-info"
					>
						<a ngbNavLink>IVAS Information</a>
						<ng-template ngbNavContent>
							<app-ivas-data-integration
								[userAsin]="userAsin"
								[userNIN]="userDetails?.nin"
							></app-ivas-data-integration>
						</ng-template>
					</li>
					<li
						ngbNavItem
						id="ansaa-info"
					>
						<a ngbNavLink>Transport Information</a>
						<ng-template ngbNavContent>
							<app-transport-data-integration
								[userAsin]="userAsin"
								[userNIN]="userDetails?.nin"
							></app-transport-data-integration>
						</ng-template>
					</li>
					<li
						ngbNavItem
						id="ansaa-info"
					>
						<a ngbNavLink>Haulage Information</a>
						<ng-template ngbNavContent>
							<app-haulage-data-integration
								[userAsin]="userAsin"
								[userNIN]="userDetails?.nin"
							></app-haulage-data-integration>
						</ng-template>
					</li>
					<li
						ngbNavItem
						id="ansaa-info"
					>
						<a ngbNavLink>MOT</a>
						<ng-template ngbNavContent>
							<app-mot-data-integration
								[userAsin]="userAsin"
								[userNIN]="userDetails?.nin"
							></app-mot-data-integration>
						</ng-template>
					</li>

					<li
						ngbNavItem
						id="ansaa-info"
					>
						<a ngbNavLink>ARTMA</a>
						<ng-template ngbNavContent>
							<app-artma-data-integration
								[userAsin]="userAsin"
								[userNIN]="userDetails?.nin"
							></app-artma-data-integration>
						</ng-template>
					</li>

					<li
						ngbNavItem
						id="ansaa-info"
					>
						<a ngbNavLink>ANSPPB</a>
						<ng-template ngbNavContent>
							<app-ansppb-data-integration
								[userAsin]="userAsin"
								[userNIN]="userDetails?.nin"
							></app-ansppb-data-integration>
						</ng-template>
					</li>

					<li
						ngbNavItem
						id="ansaa-info"
					>
						<a ngbNavLink>Ministry Of Culture</a>
						<ng-template ngbNavContent>
							<app-culture-data-integration
								[userAsin]="userAsin"
								[userNIN]="userDetails?.nin"
							></app-culture-data-integration>
						</ng-template>
					</li>
				</ul>
      		</div>

		<button
			type="button"
			class="btn btn-outline-secondary btn-sm flex-shrink-0"
			(click)="navigateTab(1)"
			[disabled]="isLastTab"
			aria-label="Next tab"
		>
			<span class="iconify" data-icon="lucide:step-forward"></span>
		</button>
    </div>

    <div [ngbNavOutlet]="nav" class="mt-4"></div>
  </div>
</div>

<!-- <div style="position: sticky !important; bottom: 0 !important"> -->
	<app-footer
		*ngIf="hasAccess(['ADMIN'])"
		class="m-hidden"
	></app-footer>
	<app-mda-footer
		*ngIf="hasAccess(['MDA'])"
		class="m-hidden"
	></app-mda-footer>
<!-- </div> -->
